import { Paper, Skeleton, Stack } from '@mui/material';
import React from 'react';

export default function NotificationLoadingCard({ forwardRef }) {
  return (
    <Paper
      ref={forwardRef}
      sx={{
        p: 1,
        pr: 2,
        boxShadow: 'none',
        borderRadius: 0,
      }}
    >
      <Stack alignItems="start" gap={1}>
        <Stack direction="row" gap={2} width="100%">
          <Skeleton variant="circular" width="40px" height="40px" />
          <Stack
            direction="row"
            gap={2}
            alignItems="center"
            flexGrow={1}
            justifyContent="space-between"
          >
            <Skeleton variant="text" width="100%" />
            <Skeleton width="30px" />
          </Stack>
        </Stack>
        <Skeleton width="50px" sx={{ ml: 7 }} />
      </Stack>
    </Paper>
  );
}
